var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-confirm',{attrs:{"type":"success","message":"Laporan akan divalidasi. Apakah Anda yakin data yang dibuat sudah benar?","visible":_vm.visible},on:{"close":function($event){return _vm.$emit('close')},"confirmed":_vm.onConfirmed}}),(_vm.loading)?_c('loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }